/**
 * @fileoverview POST handler for the "/:app_group_id/operator_mcp_connections/:connection_id/call_tool" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppGroupIdOperatorMcpConnectionsConnectionIdCallToolCacheKeys } from "./constants";
import type {
  PostAppGroupIdOperatorMcpConnectionsConnectionIdCallToolProps,
  PostAppGroupIdOperatorMcpConnectionsConnectionIdCallToolResult,
} from "./types";

export const postAppGroupIdOperatorMcpConnectionsConnectionIdCallTool = reactQueryMutationAdapter(
  postAppGroupIdOperatorMcpConnectionsConnectionIdCallToolCacheKeys,
  ({
    appGroupId,
    connectionId,
    toolName,
    arguments: toolArguments,
  }: PostAppGroupIdOperatorMcpConnectionsConnectionIdCallToolProps): Promise<PostAppGroupIdOperatorMcpConnectionsConnectionIdCallToolResult> => {
    // Every error body is written for the model, so the caller turns it into the tool's failure.
    return fetch(
      `/${appGroupId}/operator_mcp_connections/${connectionId}/call_tool`,
      "POST",
      { tool_name: toolName, arguments: toolArguments },
      undefined,
      { propagateFetchRequestError: false }
    );
  }
);
